import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'agenda-customer-ui-option-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './optionList.component.html',
  styleUrls: ['./optionList.component.scss'],
})
export class OptionListComponent {
  services = input();
}
